import { Component, OnInit } from '@angular/core';
import { FormpadreComponent } from "../formpadre/formpadre.component";
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from "../../../store/actions/utils.action";
import { ExcepcionesComponent } from "../../../utilerias/excepciones/excepciones.component";
import {
    ICheckbox, IColumnchooser,
    IColumnHiding,
    IColumns, IEditing,
    IExportExcel,
    IGridOptions,
    IScroll,
    ISearchPanel,
    Toolbar
} from "../../../interfaces";
import { MatDialog } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { AppState } from "../../../store/app.states";
import { BaseService } from "../../../services/base.service";
import { CoalService } from "../../../services/coal.service";
import { AsignaBreadcrumb } from "../../../store/actions/permisos.actions";
import { Datos } from "../../../models/datos.model";
import { FormhijoComponent } from "../formhijo/formhijo.component";
import { Router } from "@angular/router";

@Component({
    selector: 'app-datos-catalogo',
    templateUrl: './datos-catalogo.component.html',
    styleUrls: ['./datos-catalogo.component.scss']
})
export class DatosCatalogoComponent implements OnInit {

    // Grid variables
    gridOptions: IGridOptions;
    columns: IColumns[];
    exportExcel: IExportExcel;
    searchPanel: ISearchPanel;
    scroll: IScroll;
    toolbar: Toolbar[];
    columnHiding: IColumnHiding;
    Checkbox: ICheckbox;
    Editing: IEditing;
    Columnchooser: IColumnchooser;
    datos: any = [];
    modulo: any;
    datosevent: any;
    claveModulo = 'app-editar';
    queryString: any;
    currparent: any;
    constructor(public dialog: MatDialog,
        private readonly store: Store<AppState>,
        private baseService: BaseService,
        private srvcoal: CoalService,
        private router: Router) {
        this.store.dispatch(AsignaBreadcrumb({
            breadcrumb: null
        }));
    }

    ngOnInit(): void {
        this.queryString = window.location.search;
        const urlParams = new URLSearchParams(this.queryString);
        this.currparent = urlParams.get('id');

        const getStateUser = this.baseService.getUserData();


        this.modulo = Datos.GetModulo(this.claveModulo, getStateUser.permissions.modules);
        if (this.modulo.breadcrumb) {
            const breadcrumb = Datos.GetConfiguracionBreadCrumb(this.modulo.breadcrumb);
            this.store.dispatch(AsignaBreadcrumb({
                breadcrumb
            }));
        }
        this.store.dispatch(MostrarSpinner())
        this.getdata();
        this.Grid();



    }
    getdata() {
        this.srvcoal.getService('catalogoDinamico/GetCatalogoDinamicoHijo?idPadre=' + this.currparent).subscribe((res: any) => {
            //console.log(res);
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.datos = res.recordsets[0];
                //console.log(this.datos)

            }
            this.store.dispatch(OcultarSpinner())
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            this.store.dispatch(OcultarSpinner())
        });
    }

    Grid() {
        this.toolbar = [];
        /*
       Columnas de la tabla
       */
        try {
            this.columns = [
                {
                    caption: 'ID',
                    dataField: 'id',
                    allowEditing: false
                },
                {
                    caption: 'Nombre',
                    dataField: 'nombre',
                    name: 'nombre'
                },
                {
                    caption: 'Valor',
                    dataField: 'valor',
                    name: 'valor'
                },
                {
                    caption: 'Activo',
                    dataField: 'activo'
                }
            ];

            /*
            Parametros de Paginacion de Grit
            */
            const pageSizes = ['10', '25', '50', '100'];

            /*
            Parametros de Exploracion
            */
            this.exportExcel = { enabled: true, fileName: 'Listado de caja' };
            // ******************PARAMETROS DE COLUMNAS RESPONSIVAS EN CASO DE NO USAR HIDDING PRIORITY**************** */
            this.columnHiding = { hide: true };
            // ******************PARAMETROS DE PARA CHECKBOX**************** */
            this.Checkbox = { checkboxmode: 'multiple' };  // *desactivar con none*/
            // ******************PARAMETROS DE PARA EDITAR GRID**************** */
            this.Editing = { allowupdate: true }; // *cambiar a batch para editar varias celdas a la vez*/
            // ******************PARAMETROS DE PARA SELECCION DE COLUMNAS**************** */
            this.Columnchooser = { columnchooser: true };

            /*
            Parametros de Search
            */
            this.searchPanel = {
                visible: true,
                width: 200,
                placeholder: 'Buscar...',
                filterRow: true
            };

            /*
            Parametros de Scroll
            */
            this.scroll = { mode: 'standard' };
            //  if (this.modulo.camposClase.find(x => x.nombre === 'crearCaja')) {
            this.toolbar.push(
                {
                    location: 'after',
                    widget: 'dxButton',
                    locateInMenu: 'auto',
                    options: {
                        width: 90,
                        text: 'Agregar',
                        onClick: this.receiveMessage.bind(this, 'crear')
                    },
                    visible: true
                }
            );
            // }

        } catch (error) {
            this.Excepciones(error, 1);
        }
    }

    Cancelar() {
        this.router.navigateByUrl('/catalogos');
    }
    datosMessage($event) {
        try {
            //console.log($event)
            this.datosevent = $event.data;
        } catch (error) {
            this.Excepciones(error, 1);
        }
    }
    receiveMessage($event) {
        //console.log($event);
        if ($event == "crear") {
            this.crear_nuevo();
        }

    }

    crear_nuevo() {
        let dialogRef = this.dialog.open(FormhijoComponent, {

            data: { data_sel: this.currparent },
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                //console.log(`Dialog result: ${result["nombre"].value}`);
                const dictret = {
                    nombre: result["nombre"].value,
                    idPadre: this.currparent,
                    valor: result["valor"].value
                }
                this.srvcoal.postService('catalogoDinamico/PostCatalogoDinamicoHijo', dictret).subscribe((res: any) => {
                    //console.log(res);
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                    } else if (res.excepcion) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                    } else {
                        this.getdata()

                    }
                    this.store.dispatch(OcultarSpinner())
                }, (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                    this.store.dispatch(OcultarSpinner())
                });
            }


        });

    }
    Actializar(data) {
        //console.log(data)
        if (data.data) {
            //console.log(`Dialog result: ${data.data}`);
            this.srvcoal.putService('catalogoDinamico/PutCatalogoDinamicoHijo', data.data).subscribe((res: any) => {
                //console.log(res);
                if (res.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                } else if (res.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                } else {
                    this.getdata()

                }
                this.store.dispatch(OcultarSpinner())
            }, (error: any) => {
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                this.store.dispatch(OcultarSpinner())
            });
        }
    }
    Excepciones(pila, tipoExcepcion: number) {
        try {
            const dialogRef = this.dialog.open(ExcepcionesComponent, {
                width: '60%',
                data: {
                    idTipoExcepcion: tipoExcepcion,
                    idUsuario: 1,
                    idOperacion: 1,
                    idAplicacion: 1,
                    moduloExcepcion: 'sel-caja-historial.component',
                    mensajeExcepcion: '',
                    stack: pila
                }
            });
            dialogRef.afterClosed().subscribe((result: any) => { });
        } catch (error) {
            console.error(error);
        }
    }

}
